import { numberFormatter } from "@common/helpers/number";

export type AccrualTaskConfirmActionKind = "confirmAll" | "confirmSelected";

export interface AccrualTaskConfirmAction {
    label: string;
    hotKey: "mod+enter" | "enter";
    description: string;
    kind: AccrualTaskConfirmActionKind;
}

interface GetAccrualTaskConfirmActionParams {
    selectedCount: number;
    hasSelectedAll: boolean;
    haveFiltersChanged: boolean;
}

/**
 * Label, shortcut and action of the accrual task bar's Confirm button. With
 * nothing selected it confirms every row on the tab; otherwise the selection.
 * Select-all spans pages, so it confirms through the filter-based path.
 */
export const getAccrualTaskConfirmAction = ({
    selectedCount,
    hasSelectedAll,
    haveFiltersChanged,
}: GetAccrualTaskConfirmActionParams): AccrualTaskConfirmAction => {
    if (selectedCount === 0) {
        return haveFiltersChanged
            ? {
                  label: "Confirm filtered",
                  hotKey: "mod+enter",
                  description: "Confirm filtered transactions",
                  kind: "confirmAll",
              }
            : {
                  label: "Confirm all",
                  hotKey: "mod+enter",
                  description: "Confirm all transactions",
                  kind: "confirmAll",
              };
    }

    return {
        label:
            selectedCount === 1
                ? "Confirm"
                : `Confirm selected (${numberFormatter.format(selectedCount)})`,
        hotKey: "enter",
        description: "Confirm selected transactions",
        kind: hasSelectedAll ? "confirmAll" : "confirmSelected",
    };
};
